import { render } from "./AirwallexTransferList.vue?vue&type=template&id=1e15a72c&scoped=true"
import script from "./AirwallexTransferList.vue?vue&type=script&lang=js"
export * from "./AirwallexTransferList.vue?vue&type=script&lang=js"

import "./AirwallexTransferList.vue?vue&type=style&index=0&id=1e15a72c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e15a72c"]])

export default __exports__